import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { uploadingFile } from "src/recoil/atoms/global";

const SelectFileButton = ({ setToggle, disabled }) => {
  const { t } = useTranslation("flight-simulator");
  const globalUploadingField = useRecoilValue(uploadingFile);
  return (
    <div>
      <span
        className={classNames("btn btn-secondary width-by-px-160", { "disabled": globalUploadingField || disabled })}
        role="button"
        onClick={() => {
          if (!globalUploadingField) {
            setToggle(true);
          }
        }}
      >
        {t("new.select_file")}
      </span>
    </div>
  );
};

export default SelectFileButton;
